import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { Panel, LiveTag, TokenLogo, VerifiedBadge, StarButton } from "../components/common/Panel";
import { getTokens } from "../lib/api";
import { shorten, fmtNum } from "../lib/format";
import { useWatchlist } from "../hooks/useWatchlist";

export default function Tokens() {
  const [tokens, setTokens] = useState([]);
  const [loading, setLoading] = useState(true);
  const { isStarred, toggle, list } = useWatchlist();

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try { const d = await getTokens(); if (alive) { setTokens(d.tokens); setLoading(false); } } catch {}
    };
    load();
    const id = setInterval(load, 6000);
    return () => { alive = false; clearInterval(id); };
  }, []);

  // favourites first, preserving original order within each group
  const sorted = useMemo(() => {
    return [...tokens].sort((a, b) => {
      const sa = isStarred(a.address) ? 0 : 1;
      const sb = isStarred(b.address) ? 0 : 1;
      return sa - sb;
    });
  }, [tokens, isStarred]);

  const starredCount = tokens.filter((t) => isStarred(t.address)).length;

  return (
    <div className="fade-in" data-testid="tokens-page">
      <div className="mb-4">
        <span className="eyebrow" style={{ color: "var(--amber)" }}>Assets</span>
        <h1 className="font-display text-[24px] font-extrabold mt-1">BCC-20 Tokens</h1>
        <p className="text-[13px] mt-1" style={{ color: "var(--muted)" }}>Tokens deployed on Blokista Chain — tracked by on-chain Transfer events. Star a token to keep it at the top.</p>
      </div>
      <Panel
        title="Token Registry"
        subtitle={starredCount ? `${starredCount} starred` : ""}
        action={<LiveTag />}
        bodyClass="overflow-auto"
        testId="panel-token-registry"
      >
        <table className="dt">
          <thead><tr><th style={{ width: 40 }}></th><th>#</th><th>Token</th><th>Symbol</th><th>Contract</th><th>Total Supply</th><th>Holders</th><th>Transfers</th></tr></thead>
          <tbody>
            {sorted.map((t, i) => (
              <tr key={t.address} onClick={() => (window.location.href = `/token/${t.address}`)} data-testid={`token-row-${i}`}
                  className={isStarred(t.address) ? "row-active" : ""}>
                <td><StarButton starred={isStarred(t.address)} onToggle={() => toggle(t.address)} testId={`star-token-${i}`} /></td>
                <td className="mono" style={{ color: "var(--muted)" }}>{i + 1}</td>
                <td>
                  <div className="flex items-center gap-2.5">
                    <TokenLogo logo={t.logo} symbol={t.symbol} size={24} />
                    <span className="font-display font-semibold">{t.name}</span>
                    {t.verified && <VerifiedBadge small />}
                  </div>
                </td>
                <td><span className="pill pill-amber">{t.symbol}</span></td>
                <td><Link to={`/token/${t.address}`} className="link-amber mono text-[12px]" onClick={(e) => e.stopPropagation()}>{shorten(t.address, 8, 6)}</Link></td>
                <td className="mono">{fmtNum(t.totalSupply)}</td>
                <td className="mono">{fmtNum(t.holders)}</td>
                <td className="mono" style={{ color: "var(--muted)" }}>{fmtNum(t.transfers)}</td>
              </tr>
            ))}
            {!loading && tokens.length === 0 && <tr><td colSpan={8} className="text-center py-10" style={{ color: "var(--muted)" }}>No tokens deployed yet. Use the Contracts console to deploy one.</td></tr>}
            {loading && <tr><td colSpan={8} className="text-center py-10" style={{ color: "var(--muted)" }}>Loading…</td></tr>}
          </tbody>
        </table>
      </Panel>
    </div>
  );
}
